import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import Cookies from 'js-cookie';
import Localization from './utils/localization';

const legacyNamespaces = ['signup', 'tour', 'webapp', 'modal', 'doctor-signup', 'consultDoctor'];

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: Localization.getSupportedLocales(),
        backend: {
            // translation file path
            loadPath: (_, ns) => {
                return legacyNamespaces.includes(ns[0])
                    ? '/locale/i18n/{{ns}}/{{lng}}.json'
                    : '/locale/{{lng}}/{{ns}}.json';
            }
        },
        fallbackLng: 'en-NG',
        lng: Cookies.get('i18next') || Localization.getPrimaryLocale(),
        debug: false,
        // can have multiple namespaces, in case you want to divide a huge
        // translation into smaller pieces and load them on demand
        ns: ['common', 'sign_up', 'signup', 'tour', 'webapp', 'modal'],
        detection: {
            order: ['cookie', 'localStorage', 'htmlTag', 'path', 'subdomain'],
            caches: ['cookie'],
            lookupCookie: 'i18next'
        },
        interpolation: {
            espaceValue: false,
            formatSeparator: ',',
            format(value, format, lng, options = {}) {
                let locale = lng || Localization.getPrimaryLocale();
                const formatParams = options.formatParams || {};

                if (format === 'currency') {
                    let currency = appConfig.countryCurrency;

                    for (const key in formatParams) {
                        if (options[key] === value) {
                            const formatOptions = formatParams[key];
                            currency = formatOptions.currency || currency;
                            locale = formatOptions.locale || locale;
                            break;
                        }
                    }

                    currency = options.currency || currency;
                    locale = options.locale || locale;

                    return new Intl.NumberFormat(locale, {
                        style: 'currency',
                        currency
                    }).format(value);
                }

                if (format === 'datetime') {
                    let dateOptions = {
                        dateStyle: 'short',
                        timeStyle: 'short',
                        hour12: true 
                    };

                    for (const key in formatParams) {
                        if (options[key] === value) {
                          const formatOptions = formatParams[key];
                          return new Intl.DateTimeFormat(formatOptions.locale || locale, formatOptions).format(new Date(value));
                        }
                      }

                    return new Intl.DateTimeFormat(locale, dateOptions).format(new Date(value));
                }

                if (format === 'number') {
                    return new Intl.NumberFormat(lng).format(value);
                }

                return value;
            }
        },
        react: {
            useSuspense: true
        }
    });

export default i18n;
